import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import IconButton from '@mui/material/IconButton';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import Tooltip from '@mui/material/Tooltip';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import {EditCalendarOutlineIcon} from "../../styles/icons";
const SchedulePatientButton = props => {
  const {iconOnly, textOnly} = props;
  const navigate = useNavigate();
  const patientId = (
    isString(props.patientId) || isNumber(props.patientId)
    ? props.patientId
    : get(props, 'patient.id')
  ) || '';
  const url = `/providers/appointments/patients/${patientId}`;
  const onClick = () => navigate(url);
  const childProps = {
    onClick,
    disabled: !patientId,
    sx: props.sx,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    endIcon: iconOnly || textOnly ? null : <CalendarIcon/>,
    fullWidth: props.fullWidth || null,
    size: props.size
  };
  return (
    iconOnly
    ? <Tooltip title='Schedule'>
      <IconButton {...childProps}>
        <EditCalendarOutlineIcon fill={props.fill || 'var(--primary)'}/>
      </IconButton>
    </Tooltip>
    : <Button {...childProps} f>
        Schedule
    </Button>
  );
};

SchedulePatientButton.defaultProps = {
  iconOnly: false,
  textOnly: false,
};

SchedulePatientButton.propTypes = {
  patient: PropTypes.object,
  patientId: PropTypes.string, // either this or the patient
  iconOnly: PropTypes.bool,
};

export default SchedulePatientButton;
